var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Modal",
    {
      attrs: {
        title: "New import format",
        closeEnabled: !_vm.uploading,
        confirmEnabled: !_vm.uploading,
        confirmMessage: _vm.uploading
          ? "Saving..."
          : _vm.dirty
          ? "Save*"
          : "Save",
        fullscreen: "",
      },
      on: {
        confirm: _vm.uploadFormat,
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("h5", { staticClass: "pull-left" }, [
                _c("span", { staticClass: "fa fa-question-circle text-muted" }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticStyle: { "font-weight": "bold" },
                    attrs: {
                      href: "https://blacklab.ivdnt.org/how-to-configure-indexing.html",
                      target: "_blank",
                    },
                  },
                  [_vm._v("How to write your own format")]
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "column",
            height: "100%",
            position: "relative",
            gap: "15px",
          },
          on: {
            dragover: function ($event) {
              $event.preventDefault()
              return _vm.onDragOver.apply(null, arguments)
            },
            dragleave: function ($event) {
              $event.preventDefault()
              return _vm.onDragLeave.apply(null, arguments)
            },
            drop: function ($event) {
              $event.preventDefault()
              return _vm.onDrop.apply(null, arguments)
            },
          },
        },
        [
          _vm.dragActive
            ? _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    inset: "0",
                    background: "rgba(0,0,0,0.15)",
                    "z-index": "10",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    "pointer-events": "none",
                  },
                },
                [
                  _c(
                    "h2",
                    {
                      staticStyle: {
                        color: "#333",
                        background: "#fff",
                        padding: "2em 3em",
                        "border-radius": "10px",
                        "box-shadow": "0 2px 8px #0002",
                        "pointer-events": "none",
                      },
                    },
                    [_vm._v("Drop file to load")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "flex-start",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "form-group",
                  staticStyle: {
                    "margin-right": "50px",
                    "margin-bottom": "0",
                    flex: "1 1 auto",
                  },
                },
                [
                  _c("label", { attrs: { for: "format_name" } }, [
                    _vm._v("Format name"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "input-group",
                      staticStyle: { width: "100%" },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.lazy",
                            value: _vm.formatName,
                            expression: "formatName",
                            modifiers: { lazy: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "format_name",
                          name: "format_name",
                        },
                        domProps: { value: _vm.formatName },
                        on: {
                          change: function ($event) {
                            _vm.formatName = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("SelectPicker", {
                        staticClass: "input-group-btn",
                        attrs: {
                          options: _vm.formatTypes,
                          hideEmpty: "",
                          "data-class": "btn-primary dropdown-toggle",
                        },
                        model: {
                          value: _vm.formatLanguage,
                          callback: function ($$v) {
                            _vm.formatLanguage = $$v
                          },
                          expression: "formatLanguage",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", [
                _c(
                  "label",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "baseline",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("span", [_vm._v("Load a file")]),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _c("em", [
                        _c("span", { staticClass: "fa fa-info-circle" }),
                        _vm._v(" Or drag and drop a file anywhere"),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-flex",
                      "flex-wrap": "nowrap",
                    },
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "btn btn-primary",
                        staticStyle: { position: "relative" },
                        attrs: { for: "format_file" },
                      },
                      [
                        _c("input", {
                          staticStyle: {
                            position: "absolute",
                            left: "0",
                            top: "0",
                            width: "0px",
                            height: "100%",
                            "padding-left": "100%",
                            opacity: "0",
                            cursor: "pointer",
                            overflow: "hidden",
                          },
                          attrs: {
                            type: "file",
                            name: "format_file",
                            id: "format_file",
                            title:
                              "Open a file from your computer. You can also drag and drop a file.",
                          },
                          on: { change: _vm.loadFormatFromDisk },
                        }),
                        _vm._v("\n\t\t\t\t\t\tOpen file...\n\t\t\t\t\t"),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticStyle: {
                          padding: "0 0.5em",
                          "align-self": "flex-end",
                        },
                      },
                      [_vm._v("Or")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-flex",
                          "flex-wrap": "nowrap",
                          "flex-direction": "row",
                        },
                      },
                      [
                        _c("SelectPicker", {
                          attrs: {
                            options: _vm.formatOptions,
                            "data-style":
                              "border-right: none; border-top-right-radius: 0; border-bottom-right-radius: 0;",
                            right: "",
                            showValues: true,
                            searchable: "",
                            placeholder: "Select an existing format",
                            hideEmpty: "",
                            allowHtml: "",
                            "data-menu-width": "auto",
                            container: "body",
                          },
                          model: {
                            value: _vm.formatPresetName,
                            callback: function ($$v) {
                              _vm.formatPresetName = $$v
                            },
                            expression: "formatPresetName",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            staticStyle: {
                              "border-top-left-radius": "0",
                              "border-bottom-left-radius": "0",
                            },
                            attrs: {
                              disabled:
                                !_vm.formatPresetName || _vm.downloading,
                            },
                            on: { click: _vm.downloadFormat },
                          },
                          [_vm._v("Load")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.error
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger",
                  staticStyle: { margin: "0" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "close",
                      attrs: { href: "#", "aria-label": "close" },
                      on: {
                        click: function ($event) {
                          _vm.error = ""
                        },
                      },
                    },
                    [_vm._v("×")]
                  ),
                  _vm._v("\n\t\t\t" + _vm._s(_vm.error) + "\n\t\t"),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("MonacoEditor", {
            staticStyle: { "flex-grow": "1" },
            attrs: {
              options: _vm.editorOptions,
              language: _vm.formatLanguage,
              filename: _vm.fullFormatName,
            },
            on: {
              input: function ($event) {
                _vm.dirty = true
              },
            },
            model: {
              value: _vm.formatContents,
              callback: function ($$v) {
                _vm.formatContents = $$v
              },
              expression: "formatContents",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }